export default defineNuxtRouteMiddleware(async (to, from) => {
  const { isAuthenticated, fetchUser } = useUser()

  // Allow access to login page
  if (to.path === '/login') {
    // If already authenticated, redirect to home
    if (isAuthenticated.value) {
      return navigateTo('/')
    }
    return
  }

  // Allow access to OAuth entrypoints (handled on the server side)
  if (to.path.startsWith('/auth/')) {
    return
  }

  // Require authentication for all other pages
  if (!isAuthenticated.value) {
    // Try to restore auth state from existing session cookie
    try {
      await fetchUser()
    } catch {
      // Ignore and redirect below
    }

    if (isAuthenticated.value) {
      return
    }

    return navigateTo('/login')
  }
})

